import {categories} from "./tableModules/categories"
import {contacts} from './tableModules/contacts'
import {forms} from './tableModules/forms'
import {fundingPrograms} from './tableModules/fundingPrograms'
import {loginProviders} from './tableModules/loginProviders'
import {mailTemplates} from './tableModules/mailTemplates'
import {mails} from './tableModules/mails'
import {organisationUsers} from "./tableModules/organisationUsers"
import {organisations} from "./tableModules/organisations"
import {parishes} from './tableModules/parishes'
import {paymentRuns} from "./tableModules/paymentRuns"
import {payments} from "./tableModules/payments"
import {processes} from './tableModules/processes'
import {regions} from './tableModules/regions'
import {roles} from "./tableModules/roles"
import {statisticForms} from "./tableModules/statisticForms"
import {statisticProcessTransfers} from "./tableModules/statisticProcessTransfers"
import {statisticProcesses} from './tableModules/statisticProcesses'
import {statisticSurveyPeriods} from "./tableModules/statisticSurveyPeriods"
import {statisticSurveys} from "./tableModules/statisticSurveys"
import {statusNotifications} from "./tableModules/statusNotifications"
import {statuses} from "./tableModules/statuses"
import {userOrganisations} from "./tableModules/userOrganisations"
import {users} from './tableModules/users'
import {usersFrontend} from './tableModules/usersFrontend'
import {years} from "./tableModules/years"

export const tableModules: TableModules = {
    categories,
    contacts,
    forms,
    fundingPrograms,
    loginProviders,
    mailTemplates,
    mails,
    organisationUsers,
    organisations,
    parishes,
    paymentRuns,
    payments,
    processes,
    processGroups: {
        ...processes,
        name: 'processGroups',
    },
    regions,
    regionParishes: {
        ...parishes,
        columns: parishes.columns.filter(column => column.name !== 'region_name').map(
            column => column.name === 'customName' ? {...column, width: 'w-1/2 md:w-1/3'} : column
        )
    },
    roles,
    statisticForms,
    statisticProcesses,
    statisticProcessTransfers,
    statisticSurveyPeriods,
    statisticSurveys,
    statusNotifications,
    statuses,
    testUsers: {
        ...users,
        name: 'testUsers'
    } as TableModule,
    userOrganisations,
    users,
    usersFrontend,
    years,
}
